import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Grid, Typography, TextField, Button, Divider } from '@mui/material';
import { fetchPost } from '../../api/common';
import { Profile } from '@par/shared/types/player';
import './styles.css';

type PropTypes = {
  setProfile: (profile: Profile) => void;
};

export const ResetPassword = ({ setProfile }: PropTypes) => {
  const passwordRef = useRef<HTMLInputElement>(null);
  const passwordConfirmRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (event: any) => {
    //Prevent page reload
    event.preventDefault();

    if (!passwordRef.current || !passwordConfirmRef.current) {
      return setError('Fill in all fields');
    }

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError('Passwords do not match');
    }

    try {
      setError('');
      setLoading(true);
      const res = await fetchPost(`/authenticate/reset-password/${token}`, {
        password: passwordRef.current.value,
      });
      if (res && res.user) {
        setProfile(res.user);
        navigate('/');
      }
    } catch {
      setError('Failed to reset password');
    }

    setLoading(false);
  };

  const renderErrorMessage = () => (
    <Typography color="error.main">{error}</Typography>
  );

  return (
    <>
      <Grid item>{renderErrorMessage()}</Grid>
      <Grid item>
        <Typography sx={{ marginBottom: '24px' }}>
          Reset your password
        </Typography>
      </Grid>
      <Grid item>
        <form onSubmit={handleSubmit}>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <TextField
                type="password"
                placeholder="Password"
                fullWidth
                variant="outlined"
                name="pass"
                inputRef={passwordRef}
                required
              />
            </Grid>
            <Grid item>
              <TextField
                type="password"
                placeholder="Confirm Password"
                fullWidth
                variant="outlined"
                name="password-confirm"
                inputRef={passwordConfirmRef}
                required
              />
            </Grid>
            <Grid item>
              {!loading ? (
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className="button-block"
                >
                  Reset Password
                </Button>
              ) : null}
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  );
};
